import React__default, { Component, useContext } from 'react';
import { __extends } from '../../_virtual/_tslib.js';
import { ChatContext } from '../ChatContext/index.js';
import { ScrollContext } from '../Scrollable/index.js';
import TypingIndicator$1 from '../../components/TypingIndicator/index.js';
import ConversationQuery from '../ConversationQuery/index.js';

var TypingIndicatorContainer =
/** @class */
function (_super) {
  __extends(TypingIndicatorContainer, _super);

  function TypingIndicatorContainer(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      typing: []
    };
    _this.handleTypingStateChange = _this.handleTypingStateChange.bind(_this);
    return _this;
  }

  TypingIndicatorContainer.prototype.handleTypingStateChange = function (evt) {
    this.props.onTypingStatusChange();

    switch (evt.event) {
      case 'typingStarted':
        this.setState(function (prevState) {
          return {
            typing: prevState.typing.concat([evt.user])
          };
        });
        break;

      case 'typingStopped':
        this.setState(function (prevState) {
          return {
            typing: prevState.typing.filter(function (user) {
              return user.userId !== evt.user.userId;
            })
          };
        });
        break;
    }
  };

  TypingIndicatorContainer.prototype.componentDidMount = function () {
    if (this.props.conversation) {
      this.addTypingListener(this.props.conversation);
    }
  };

  TypingIndicatorContainer.prototype.componentWillReceiveProps = function (nextProps) {
    if (this.props.conversation && !nextProps.conversation) {
      this.removeTypingListener(this.props.conversation);
    }

    if (!this.props.conversation && nextProps.conversation) {
      this.addTypingListener(nextProps.conversation);
    }

    if (this.props.conversation && nextProps.conversation && nextProps.conversation.conversationId !== this.props.conversation.conversationId) {
      this.setState({
        typing: []
      });
      this.removeTypingListener(this.props.conversation);
      this.addTypingListener(nextProps.conversation);
    }
  };

  TypingIndicatorContainer.prototype.componentWillUnmount = function () {
    if (this.props.conversation) {
      this.removeTypingListener(this.props.conversation);
    }
  };

  TypingIndicatorContainer.prototype.addTypingListener = function (conversation) {
    conversation.on('typingStarted', this.handleTypingStateChange);
    conversation.on('typingStopped', this.handleTypingStateChange);
  };

  TypingIndicatorContainer.prototype.removeTypingListener = function (conversation) {
    conversation.off('typingStarted', this.handleTypingStateChange);
    conversation.off('typingStopped', this.handleTypingStateChange);
  };

  TypingIndicatorContainer.prototype.render = function () {
    return React__default.createElement(TypingIndicator$1, {
      typing: this.state.typing
    });
  };

  return TypingIndicatorContainer;
}(Component);

var TypingIndicator = (function (props) {
  var client = useContext(ChatContext).client;
  var scrollToTarget = useContext(ScrollContext).scrollToTarget;

  if (client && client.myself) {
    return React__default.createElement(ConversationQuery, {
      conversationId: props.conversationId
    }, function (_a) {
      var conversation = _a.conversation;
      return React__default.createElement(TypingIndicatorContainer, {
        client: client,
        conversation: conversation,
        onTypingStatusChange: scrollToTarget
      });
    });
  } else {
    return null;
  }
});

export default TypingIndicator;
//# sourceMappingURL=index.js.map
